var api = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/mini-css-extract-plugin/dist/loader.js!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/postcss-loader/src/index.js??ref--7-3!../../node_modules/resolve-url-loader/index.js??ref--7-4!../../node_modules/sass-loader/dist/cjs.js?sourceMap!./main.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};